import { isMorning, isMidday, isEvening } from "./dateTimePeriod";
import { AvailableSlot } from "../apiClient";

export const filterTimeSlots = (slots: AvailableSlot[]): AvailableSlot[] => {
  // Convert datetime strings to Date objects
  const slotsWithDate = slots.map(slot => ({
    ...slot,
    date: new Date(slot.datetime)
  }));

  // Categorize slots using the discrete functions
  const morningSlots = slotsWithDate.filter(({ date }) => isMorning(date));
  const midDaySlots = slotsWithDate.filter(({ date }) => isMidday(date));
  const afternoonEveningSlots = slotsWithDate.filter(({ date }) => isEvening(date));

  // Take 2 from morning, 2 from mid-day, and 2 from afternoon/evening
  const selectedSlots = [
    ...morningSlots.slice(0, 3),
    ...midDaySlots.slice(0, 3),
    ...afternoonEveningSlots.slice(0, 3)
  ];

  // Sort the selected slots by datetime
  selectedSlots.sort((a, b) => a.date.getTime() - b.date.getTime());

  // Return the filtered slots with datetime strings only
  return selectedSlots.map(({ datetime, providerId }) => ({ datetime, providerId }));
};
